import React, { useEffect, useState } from 'react';
import { UnauthenticatedError } from './UnauthenticatedError';

export function AuthGlobalHandler(): JSX.Element | null {
  const [eventDetail, setEventDetail] = useState<{ message?: string; details?: string } | null>(null);

  useEffect(() => {
    function onUnauth(e: any) {
      setEventDetail(e?.detail || { message: 'Unauthorized' });
    }
    function onAuth() {
      setEventDetail(null);
    }
    window.addEventListener('tn:unauthenticated', onUnauth as EventListener);
    window.addEventListener('tn:authenticated', onAuth as EventListener);
    return () => {
      window.removeEventListener('tn:unauthenticated', onUnauth as EventListener);
      window.removeEventListener('tn:authenticated', onAuth as EventListener);
    };
  }, []);

  if (!eventDetail) return null;

  return <UnauthenticatedError error={eventDetail.message} details={eventDetail.details} />;
}
